import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { useConfig } from '../../../context/ConfigProvider/ConfigProvider';
import { useBreakpointCreator } from '../../../hooks/useBreakpointCreator';
const StyledWidthContainer = styled('div', ({ $breakpoints }) => ({
    margin: '0 auto',
    width: '100%',
    ...$breakpoints,
}));
export const ContentWidthContainer = ({ children, }) => {
    const { breakpoints } = useConfig();
    const breakpointWidths = {
        xs: {
            maxWidth: breakpoints.sm,
        },
        sm: {
            maxWidth: breakpoints.sm,
        },
        md: {
            maxWidth: breakpoints.md,
        },
        lg: {
            maxWidth: breakpoints.lg,
        },
        xl: {
            maxWidth: breakpoints.xl,
        },
    };
    const createdBreakpoints = useBreakpointCreator(breakpointWidths);
    return (_jsx(StyledWidthContainer, { $breakpoints: createdBreakpoints, children: children }));
};
